import axios from "axios";
import { useEffect, useState } from "react";
import "./Css/QueManagment.css";
import { useNavigate } from 'react-router-dom';
import API_BASE from "../config/api";

const QueMangment = () => {
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [search, setSearch] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [examList, setExamList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [softwares, setSoftwares] = useState([]);
  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [selectedSoftware, setSelectedSoftware] = useState("");
  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const [showUploadUI, setShowUploadUI] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadSoftwareId, setUploadSoftwareId] = useState("");
  const [uploading, setUploading] = useState(false);

  const filteredData = examList.filter((item) =>
    item.questionText.toLowerCase().includes(searchQuery.toLowerCase()) &&
    (selectedSoftware ? item.softwareId == selectedSoftware : true) &&
    (selectedStandard ? item.standardId == selectedStandard : true) &&
    (selectedSubject ? item.subjectId == selectedSubject : true)
  );



  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );


  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeletePopup(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;

    try {
      await axios.delete(`${API_BASE}/api/questions/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });

      loadQuestions(); // refresh list
    } catch (err) {
      console.error(err);
    } finally {
      setShowDeletePopup(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteId(null);
  };
  const handleViewClick = (id) => {
    navigate(`/dashboard/queview/${id}`);
  };
  const handleEditClick = (id) => {
    navigate(`/dashboard/queedit/${id}`);
  };


  useEffect(() => {
    loadQuestions();
    loadDropdowns();
  }, []);

  const loadDropdowns = async (softwareId = null, standardId = null) => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/questions/dropdowns`,
        {
          params: {
            softwareId,
            standardId
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
          }
        }
      );

      setSoftwares(res.data.softwares);
      setStandards(res.data.standards);
      setSubjects(res.data.subjects);
    } catch (err) {
      console.error(err);
      alert("Dropdown load failed");
    }
  };

  const handleSoftwareChange = async (e) => {
    const id = e.target.value;

    setSelectedSoftware(id);
    setSelectedSubject("");

    await loadDropdowns(id, selectedStandard || null);
  };

  const handleStandardChange = async (e) => {
    const id = e.target.value;
    setSelectedStandard(id);
    setSelectedSoftware("");
    setSelectedSubject("");

    await loadDropdowns(null, id);
  };

  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
  };


  const loadQuestions = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/questions`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });
      setExamList(res.data);
    } catch (err) {
      console.error(err);
      alert("Questions load failed");
    }
  };

  const handleBulkUpload = async () => {
    if (!uploadSoftwareId) return alert("Select software");
    if (!uploadFile) return alert("Select file");

    try {
      setUploading(true);
      const fd = new FormData();
      fd.append("SoftwareId", uploadSoftwareId);
      fd.append("ExcelFile", uploadFile);

      const res = await axios.post(
        `${API_BASE}/api/questions/bulk-upload`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
          }
        }
      );

      alert(res.data);

      setShowUploadUI(false);
      setUploadFile(null);
      setUploading(false);

      loadQuestions(); // refresh table
    }
    catch (err) {
      console.error(err);
      alert(err.response?.data || "Upload failed");
    }
  };

  return (
    <div className="qb-container">
      <div className="exam-header">
        <h3>प्रश्न संच  </h3>
        <div className="edit-btnn">
          <button className="btnc-outlinne" style={{ cursor: 'pointer' }} onClick={() => navigate('/dashboard/quelist')} >मंजुरीसाठी प्रश्नांची यादी (९)</button>
          <button className="primary-btn" onClick={() => setShowPopup(true)}
          >प्रश्न जोडा</button>
        </div>
      </div>
      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>

        <select value={selectedStandard} onChange={handleStandardChange}>
          <option value="">इयत्ता</option>
          {standards.map(s => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>

        <select value={selectedSoftware} onChange={handleSoftwareChange} >
          <option value="">परीक्षेचे नाव</option>
          {softwares.map(s => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>

        <select value={selectedSubject} onChange={handleSubjectChange} >
          <option value="">विषय</option>
          {subjects.map(s => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>

      <div className="qb-table-wrapper">
        <table className="qb-table">
          <thead>
            <tr>
              <th>क्र.</th>
              <th>इयत्ता</th>
              <th>विषय</th>
              <th>घटक</th>
              <th>उपघटक</th>
              <th>प्रश्न</th>
              <th>पर्याय १</th>
              <th>पर्याय २</th>
              <th>पर्याय ३</th>
              <th>पर्याय ४</th>
              <th>उत्तर</th>
              <th>प्रश्न पातळी</th>
              <th>निर्मिती (created by)</th>
              <th>क्रिया</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.standard}</td>
                <td>{item.subject}</td>
                <td>{item.topic}</td>
                <td>{item.subtopic}</td>
                <td className="question-text">{item.questionText}</td>
                <td>{item.optionA}</td>
                <td>{item.optionB}</td>
                <td>{item.optionC}</td>
                <td>{item.optionD}</td>
                <td className="answer-cell">
                  {item.correctAnswer}
                  <span className="tick"> ✅</span>
                  <span className="info"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#848484" />
                  </svg></span>
                </td>

                <td>{item.difficultyLevel}</td>
                <td>{item.software}</td>
                <td className="actions">
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewClick(item.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEditClick(item.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteClick(item.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M7.6155 20.0036C7.15517 20.0036 6.77083 19.8495 6.4625 19.5411C6.15417 19.2328 6 18.8485 6 18.3881V6.00363H5V5.00363H9V4.23438H15V5.00363H19V6.00363H18V18.3881C18 18.8485 17.8458 19.2328 17.5375 19.5411C17.2292 19.8495 16.8448 20.0036 16.3845 20.0036H7.6155ZM9.80775 17.0036H10.8078V8.00363H9.80775V17.0036ZM13.1923 17.0036H14.1923V8.00363H13.1923V17.0036Z" fill="#FF1501" />
                  </svg>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showDeletePopup && (
        <div className="delete-popup-overlay" onClick={cancelDelete}>
          <div className="delete-popup-box delete-confirm-box" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 32 36" fill="none">
                <path d="M6 36C4.9 36 3.95833 35.6083 3.175 34.825C2.39167 34.0417 2 33.1 2 32V6C1.43333 6 0.958333 5.80833 0.575 5.425C0.191667 5.04167 0 4.56667 0 4C0 3.43333 0.191667 2.95833 0.575 2.575C0.958333 2.19167 1.43333 2 2 2H10C10 1.43333 10.1917 0.958333 10.575 0.575C10.9583 0.191667 11.4333 0 12 0H20C20.5667 0 21.0417 0.191667 21.425 0.575C21.8083 0.958333 22 1.43333 22 2H30C30.5667 2 31.0417 2.19167 31.425 2.575C31.8083 2.95833 32 3.43333 32 4C32 4.56667 31.8083 5.04167 31.425 5.425C31.0417 5.80833 30.5667 6 30 6V32C30 33.1 29.6083 34.0417 28.825 34.825C28.0417 35.6083 27.1 36 26 36H6ZM26 6H6V32H26V6ZM12 28C12.5667 28 13.0417 27.8083 13.425 27.425C13.8083 27.0417 14 26.5667 14 26V12C14 11.4333 13.8083 10.9583 13.425 10.575C13.0417 10.1917 12.5667 10 12 10C11.4333 10 10.9583 10.1917 10.575 10.575C10.1917 10.9583 10 11.4333 10 12V26C10 26.5667 10.1917 27.0417 10.575 27.425C10.9583 27.8083 11.4333 28 12 28ZM20 28C20.5667 28 21.0417 27.8083 21.425 27.425C21.8083 27.0417 22 26.5667 22 26V12C22 11.4333 21.8083 10.9583 21.425 10.575C21.0417 10.1917 20.5667 10 20 10C19.4333 10 18.9583 10.1917 18.575 10.575C18.1917 10.9583 18 11.4333 18 12V26C18 26.5667 18.1917 27.0417 18.575 27.425C18.9583 27.8083 19.4333 28 20 28Z" fill="#FF0000" />
              </svg>
              <h3>प्रश्न हटवण्याची खात्री करा</h3>
              <p>तुम्हाला हा प्रश्न कायमस्वरूपी हटवायचा आहे का?</p>
            </div>
            <div className="delete-popup-buttons">
              <button className="delete-cancel-btn" onClick={cancelDelete}>नाही </button>
              <button className="delete-confirm-btn" onClick={confirmDelete}>होय </button>
            </div>
          </div>
        </div>
      )}

      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
      {/* MAIN POPUP */}
      {showPopup && (
        <div className="exam-popup-overlay">
          <div className="delete-popup-box delete-confirm-box">

            <h3>प्रश्न जोडा</h3>

            <div className="exam-popup-actions">

              <button
                className="exam-popup-btn outline"
                onClick={() => {
                  setShowPopup(false);
                  setShowUploadUI(true);
                }}
              >
                Bulk Upload
              </button>

              <button
                className="exam-popup-btn primary"
                onClick={() => {
                  setShowPopup(false);
                  navigate("/dashboard/addqueform");
                }}
              >
                Add Manually
              </button>

            </div>

            <span className="exam-popup-close" onClick={() => setShowPopup(false)}>
              ✕
            </span>

          </div>
        </div>
      )}

      {/* UPLOAD POPUP */}
      {showUploadUI && (
        <div className="exam-popup-overlay">
          <div className="delete-popup-box">

            <h3>Excel Upload</h3>

            <select
              value={uploadSoftwareId}
              onChange={e => setUploadSoftwareId(e.target.value)}
            >
              <option value="">Select Software</option>
              {softwares.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>

            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={e => setUploadFile(e.target.files[0])}
            />

            <div className="exam-popup-actions">

              <button
                className="exam-popup-btn outline"
                onClick={() => setShowUploadUI(false)}
              >
                Cancel
              </button>

              <button
                className="exam-popup-btn primary"
                onClick={handleBulkUpload}
                disabled={uploading}
              >
                {uploading ? "Uploading..." : "Upload"}
              </button>

            </div>

            <span
              className="exam-popup-close"
              onClick={() => setShowUploadUI(false)}
            >
              ✕
            </span>

          </div>
        </div>
      )}
    </div>
  );
};

export default QueMangment;
